import React from 'react'
import { useInView } from 'react-intersection-observer'
import Image from '../image'

const ImageSlice = ({data}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  return (
    <div ref={ref} className={inView ? 'has-anim' : ''}>
      {data.titleContent &&
      <div className="row">
        <div className="col-12 lg-col-8 mx-auto">
          <h2 className="title title-slice mb-5 scroll-anim-el">{data.titleContent}</h2>
        </div>
      </div> }
      
      <div className={`full-width scroll-anim-el ${data.titleContent ? 'scroll-anim-el--2' : ''}`}>
        { data.link ?
          <a href={data.link} target="_blank" rel="noopener noreferrer">
            <Image
              classes="w-full"
              width="1600"
              height="690"
              sizes={{"420": [420, 240], "767": [767, 440], "1023": [1023, 440], "1440": [1440, 621] }}
              image={data.image} />
            </a>
          : <Image
          classes="w-full"
          width="1600"
          height="690"
          sizes={{"420": [420, 240], "767": [767, 440], "1023": [1023, 440], "1440": [1440, 621] }}
          image={data.image} /> }
      </div>
    </div>
  )
}

export default ImageSlice
